import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = {
    ...Abstrap.propTypes,
    color: PropTypes.oneOf([
        'error',
        'warning',
        'success',
        'inactive',
        'action',
        'action-light',
    ]),
    active: PropTypes.bool,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    active: false,
    color: 'inactive',
};

class Label extends Abstrap {

    getClassNameSchema() {
        const {
            active,
            className,
            color,
        } = this.props;
        return [
            's-label',
            `s-label--${color}`,
            active ? 's-label--active' : null,
            className,
        ];
    }

}

Label.propTypes = propTypes;

Label.defaultProps = defaultProps;

export default Label;
